import React, { useEffect, useState } from 'react';
import { ITollClass, getFormattedTollClasses } from '@adac-mp/shared';
import Skeleton from 'react-loading-skeleton';
import { ArrowRight, Typography, Drawer, Accordion, IHelperDrawerContent, IconButton } from '../../index';
import { ContentfulDrawerContent } from '../ContentfulDrawerContent';

interface ITollClaasInfoProps {
	tollClassLabel: string;
	linkText?: string;
	helperDrawer?: IHelperDrawerContent;
	reuse?: boolean;
}

export const TollClassesInfo = ({ linkText, helperDrawer, tollClassLabel, reuse = false }: ITollClaasInfoProps) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState<boolean>(false);
	const [tollClasses, setTollClasses] = useState<ITollClass[] | undefined>();

	useEffect(() => {
		if (!tollClasses && drawerIsOpen) {
			getFormattedTollClasses(setTollClasses);
		}
	}, [tollClasses, drawerIsOpen]);

	const renderTollClassAccordion = ({ id, classCode, producer, models }: ITollClass) => {
		return (
			<Accordion key={id} title={producer} className="bg-white py-2.5 px-1.5 md:py-3 hover:border-gray-400">
				<div className="flex flex-col pt-[34px] pb-3.5">
					{models?.map((model, index) => (
						<Typography
							key={index}
							className="flex justify-between py-1.5 px-3"
							color="title"
							size="baseLg">
							{model}
							<Typography color="lightText" size="baseLg">
								{tollClassLabel} {classCode}
							</Typography>
						</Typography>
					))}
				</div>
			</Accordion>
		);
	};

	const renderDrawerContent = () =>
		helperDrawer?.id ? (
			<ContentfulDrawerContent id={helperDrawer.id} />
		) : (
			<Typography className="px-4 py-6 md:py-8" size="xl" color="text">
				Wenn Ihr Fahrzeugmodell nicht in der Liste ist, dann ist ihre Mautklasse nicht 2B.
			</Typography>
		);

	const renderTollClasses = () =>
		tollClasses ? (
			<div className="flex flex-col gap-1.5">
				{tollClasses.map((tollClass) => renderTollClassAccordion(tollClass))}
			</div>
		) : (
			<Skeleton count={10} className="mb-1 h-[57.2px] md:h-[60px]" />
		);

	return (
		<>
			<IconButton
				className="border-none whitespace-nowrap group w-fit inline-flex self-center gap-2 justify-center font-bold text-base items-center focus-visible:outline-primary text-gray-200 hover:text-gray-100"
				tracking={{
					info_click: {
						label: linkText || 'Liste der Fahrzeuge der Mautklasse 2B',
						element: reuse ? 'Reuse Fahrzeugauswahl' : 'Fahrzeugauswahl',
						category: 'Content',
					},
				}}
				onClick={() => setDrawerIsOpen(true)}>
				<ArrowRight className="group-hover:[&>*]:stroke-gray-100" />
				{linkText || 'Liste der Fahrzeuge der Mautklasse 2B'}
			</IconButton>
			<Drawer
				isOpen={drawerIsOpen}
				paddingX="large"
				setIsOpen={setDrawerIsOpen}
				title={helperDrawer?.title || 'Fahrzeuge der Mautklasse 2B'}>
				{renderDrawerContent()}
				{renderTollClasses()}
			</Drawer>
		</>
	);
};
